import { Grid } from "@mui/material";
import { useAssetOutlet } from "~/pages/inventory/asset";
import { AssetConfigurationSection } from "./asset-configuration-section";
import { Loading } from "./loading";
import { RiskFactors } from "~/pages/inventory/components/RiskFactors/RiskFactors";
import { AssetTopFindings } from "~/pages/inventory/components/AssetTopFindings/AssetTopFindings";

export function OverviewTab() {
  const { asset, assetPath, hasMondooPlatformVulnPolicy } = useAssetOutlet();

  if (!assetPath) {
    return <Loading what="Overview Tab" />;
  }

  // until backend removes the platform vuln policy from the count, we are managing it here
  let policyCount = asset?.listPolicies?.totalCount || 0;
  // if there is a platform vulnerability policy, remove it from the count
  if (hasMondooPlatformVulnPolicy && policyCount > 0) {
    policyCount--;
  }

  const hasRiskFactors =
    asset?.riskFactors?.some((factor) => factor.isDetected) ?? false;

  return (
    <>
      <Grid container spacing={3} mt={3}>
        {hasRiskFactors && (
          <Grid size={{ xs: 12, md: 5 }}>
            <RiskFactors />
          </Grid>
        )}
        <Grid size={{ xs: 12, md: hasRiskFactors ? 7 : 12 }}>
          <AssetTopFindings />
        </Grid>
      </Grid>
      <AssetConfigurationSection />
    </>
  );
}
